export default {
  error: {
    FORBIDDEN: "L'opération n'est pas autorisée",
    CODE_MISMATCH_EXCEPTION: 'Code incorrect',
    EXPIRED_CODE_EXCEPTION: '@:error.CODE_MISMATCH_EXCEPTION',
    ANSWER_LOCK_CONFLICT_EXCEPTION: '@:upload_common.unable_edit_someone_editing_survey',
    ZERO_IS_NOT_AllOWED_EXCEPTION: '@:validation.invalid_zero_number',
    // COMPARISON_MISSING_EXCEPTION: '',
    // ESG_DATA_ANSWER_GROUP_VERSIONS_NOT_FOUND: '',
    // ESG_DATA_NAME_DUPLICATE_EXCEPTION: '',
    // ESG_DATA_ANSWER_GROUP_VERSIONS_ALREADY_SHARED_EXCEPTION: '',
    // ESG_DATA_ALREADY_SHARED_EXCEPTION: '',
    // ESG_DATA_UNANSWERED_SHARE_EXCEPTION: '',
    // ESG_DATA_MAX_SHARE_LIMIT_EXCEPTION: '',
    // ESG_DATA_INVITATION_EXPIRED_EXCEPTION: '',
    // ESG_DATA_USER_ALREADY_REGISTERED_EXCEPTION: '',
  },
}
